
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/video-production/get-pricing",
      function () {
        return require("private-next-pages/video-production/get-pricing/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/video-production/get-pricing"])
      });
    }
  